var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    staticClass: "mx-n3 px-3",
    attrs: {
      "width": "100%",
      "height": "100%",
      "max-width": "1080"
    }
  }, [_c('list-heading', {
    attrs: {
      "title": "자재연결 관리"
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function fn() {
        return [_c('manufacturing-material-list-sync', _vm._g({
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref) {
              var attrs = _ref.attrs,
                  on = _ref.on;
              return [_c('v-btn', _vm._g(_vm._b({
                attrs: {
                  "small": "",
                  "color": "primary"
                }
              }, 'v-btn', attrs, false), on), [_c('v-icon', {
                staticClass: "mr-1",
                attrs: {
                  "small": ""
                }
              }, [_vm._v("mdi-sync")]), _c('span', [_vm._v("MES 데이터 싱크")])], 1)];
            }
          }])
        }, {
          search: _vm.search
        }))];
      },
      proxy: true
    }])
  }), _c('manufacturing-material-list-search', _vm._b({}, 'manufacturing-material-list-search', {
    loading: _vm.loading
  }, false)), _c('v-data-table', _vm._b({
    staticClass: "v-sheet--outlined mt-4",
    attrs: {
      "disable-sort": "",
      "disable-pagination": "",
      "hide-default-footer": "",
      "items-per-page": -1
    },
    on: {
      "click:row": _vm.onClickRow
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header, index) {
      return {
        key: "item.".concat(header.value),
        fn: function fn(_ref2) {
          var value = _ref2.value,
              item = _ref2.item;
          return [_c('span', {
            key: index,
            attrs: {
              "title": header.withTitle ? header.formatter.bind(item)(value, item) : undefined
            },
            domProps: {
              "innerHTML": _vm._s(header.formatter.bind(item)(value, item))
            }
          })];
        }
      };
    }), {
      key: "item.code",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('v-list-item', {
          attrs: {
            "dense": "",
            "target": "_blank",
            "href": item.href
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_c('v-list-item-avatar', {
          attrs: {
            "color": "content"
          }
        }, [_c('v-img', {
          attrs: {
            "src": item.photo
          },
          scopedSlots: _vm._u([{
            key: "placeholder",
            fn: function fn() {
              return [_c('v-icon', [_vm._v("mdi-chip")])];
            },
            proxy: true
          }], null, true)
        })], 1), _c('v-list-item-content', [_c('v-list-item-title', {
          attrs: {
            "title": item.code
          }
        }, [_vm._v(" " + _vm._s(item.code) + " ")])], 1)], 1)];
      }
    }, {
      key: "item.shows",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c('v-switch', _vm._b({
          staticClass: "d-inline-block ml-1 mr-n3",
          on: {
            "!click": function click($event) {
              $event.stopPropagation();
            },
            "change": function change(shows) {
              return _vm.update({
                _id: item._id,
                shows: shows
              });
            }
          },
          model: {
            value: item.shows,
            callback: function callback($$v) {
              _vm.$set(item, "shows", $$v);
            },
            expression: "item.shows"
          }
        }, 'v-switch', _vm.attrs_switch, false))];
      }
    }], null, true)
  }, 'v-data-table', {
    loading: _vm.loading,
    headers: _vm.headers,
    items: _vm.items
  }, false)), _c('v-pagination', {
    staticClass: "mt-3 mx-4",
    attrs: {
      "value": _vm.page,
      "length": _vm.pageCount,
      "total-visible": 11
    },
    on: {
      "input": function input(page) {
        return _vm.$router.push({
          query: Object.assign({}, _vm.$route.query, {
            page: page
          })
        });
      }
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }